<div class="vertical-tab-list-wrapper">
  <div class="inactive" [ngClass]="selectedItem === item.name ?' active ': '' " *ngFor="let item of list"
    (click)="onTabClick(item)">{{ item.name }}</div>
</div>